<template>
  <div class="col-12">
    <template v-for="(item, key) in data">
      <table class="w-100 table table-borderless table-secondary" :key="item.id">
        <tr>
          <th class="pb-0">
            <label class="mb-0">Milník č.{{ key + 1 }} | Meilenstein Nr. {{ key + 1 }}</label>
          </th>
        </tr>
        <tr v-if="userLand == 'CZ'">
          <td colspan="2">
            <div>
              <b-form-radio v-model="item.budget" :value="0" @change="removeCurrentItem(item.id); setText(0, key)">Draft budget</b-form-radio>
              <b-form-radio v-model="item.budget" :value="1" @change="updateItems(); setText(1, key)">{{ $t('projects.activities.radio') }}</b-form-radio>
            </div>
          </td>
        </tr>
        <tr>
          <td class="w-50">
            <label>Název milníku</label>
            <b-form-input v-model="item.name_cs"></b-form-input>
          </td>
          <td class="w-50">
            <label>Bezeichnung des Meilensteines</label>
            <b-form-input v-model="item.name_de"></b-form-input>
          </td>
        </tr>
        <tr>
          <td class="w-50">
            <label v-if="item.budget == 0">Popis milníku, zapojení partnera, časový plán (max. 1500 znaků)</label>
            <Label v-else>Popis každé typové aktivity s délkou trvání (jednodenní – více než 4 hodiny, dvoudenní, atd.), počtem CZ a AT účastníků, zapojením partnera a plánovaným termínem realizace v rámci Milníku.</Label>
            <b-textarea v-model="item.description_cs" max-rows="8" rows="2"></b-textarea>
          </td>
          <td class="w-50">
            <label v-if="item.budget == 0">Beschreibung des Meilensteines, Einbindung des Partners, Zeitplan (max. 1800 Zeichen)</label>
            <label v-else>Beschreibung jeder typischen Aktivität mit der Dauer (ein­tägig – mehr als 4 Stunden, zwei­tägig, usw.), Anzahl der CZ- und AT-Teilnehmer, Einbindung der Partner und geplantem Durchführungstermin im Rahmen des Meilensteins.</label>
            <b-textarea v-model="item.description_de" max-rows="8" rows="2"></b-textarea>
          </td>
        </tr>

        <tr v-if="item.budget == 0">
          <td class="w-50">
            <label>Výstup milníku a jeho kvantifikace (max. 200 znaků)</label>
            <b-textarea v-model="item.activities_cs" max-rows="8" rows="2"></b-textarea>
          </td>
          <td class="w-50">
            <label>Output des Meilensteines und seine Quantifizierung (max. 300 Zeichen</label>
            <b-textarea v-model="item.activities_de" max-rows="8" rows="2"></b-textarea>
          </td>
        </tr>

        <tr v-if="userLand == 'CZ' && item.budget == 1">
          <td colspan="2">
            <project-activity-items :id-article-activity="item.id"
                                    ref="project_activity_items"
                                    @update-total="handleTotalUpdate"

            ></project-activity-items>
          </td>
        </tr>

        <tr>
          <td class="w-50">
            <label>{{ 'Podklady ke splnění milníku (max. 700 znaků)' }}
              <span :id="'popover-proof-cs-'+item.id"><b-icon aria-hidden="true" icon="info-circle"></b-icon></span>
              <b-popover :target="'popover-proof-cs-'+item.id" triggers="hover focus">
                viz Příručka pro FMP bod 6.2.1.
              </b-popover>
            </label>
            <b-textarea v-model="item.proof_cs" :readonly="userLand == 'CZ' && item.budget == 1" max-rows="8" rows="2"></b-textarea>
          </td>
          <td class="w-50">
            <label>{{ 'Nachweise zur Erfüllung des Meilensteines (max. 900 Zeichen)' }}
              <span :id="'popover-proof-de'+item.id"><b-icon aria-hidden="true" icon="info-circle"></b-icon></span>
              <b-popover :target="'popover-proof-de'+item.id" triggers="hover focus">
                Siehe Handbuch für die KPFs Punkt 6.2.1.
              </b-popover>
            </label>
            <b-textarea v-model="item.proof_de" :readonly="userLand == 'CZ' && item.budget == 1" max-rows="8" rows="2"></b-textarea>
          </td>
        </tr>


        <tr>
          <td colspan="2" class="pt-0">
            <b-button @click="deleteItem(item.id)" type="button" size="sm" variant="danger">
              <b-icon class="clickable" icon="trash-fill" variant=""></b-icon>&nbsp;
              {{ $t('projects.activities.removeBtn') }}

            </b-button>
          </td>
        </tr>
      </table>
    </template>
    <b-button @click="addItem()" type="button" size="sm" class="mb-3" variant="primary">
      <b-icon class="clickable" icon="plus-square-fill" variant=""></b-icon>&nbsp;
      {{ $t('projects.activities.addBtn') }}
    </b-button>

  </div>
</template>

<script>
import ProjectActivityItems from "./project-activity-items.vue";

export default {
  name: "project-activities",
  components: {ProjectActivityItems},
  props: {
    idArticle: {
      type: Number
    },
    userLand: {
      type: String
    }
  },
  data() {
    return {
      data: {},
      totalsMap: {},
    }
  },
  methods: {

    setText(type, key) {
      if (type == 0) {
        this.data[key].proof_cs = '';
        this.data[key].proof_de = '';
      }
      if (type == 1) {
        this.data[key].proof_cs = `• pozvánka na každou realizovanou akci,
• program každé realizované akce včetně časového harmonogramu pro prokázání doby/délky trvání akce,
• prezenční listina nebo jiný dokument prokazující počet
• fotodokumentace z každé akce
• dokumenty k prokázání splnění povinné publicity
• prezenční listina nebo jiný dokument prokazující počet účastníků`;

        this.data[key].proof_de = `• Einladung zu jeder durchgeführten Veranstaltung,
• Programm jeder durchgeführten Veranstaltung inklusive Zeitplan zur Nachweisung der Dauer,
• Teilnahmeliste oder ein anderes Dokument zum Nachweis der Teilnehmerzahl,
• Fotodokumentation von jeder Veranstaltung,
• Dokumente zum Nachweis der Einhaltung der verpflichtenden Öffentlichkeitsarbeit.`;
      }
      return type
    },

    async loadData() {
      try {
        const response = await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/activities/list.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          params: {
            'id_articles': this.idArticle,
            'type': 1,
          },
          method: 'GET'
        });

        this.data = response.data;

      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    async updateItems() {


      await Promise.all(
          this.$refs.project_activity_items?.map((comp) => comp?.updateItems())
      );

      try {
        await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/activities/update-items.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: {
            'data': this.data,
            'id_articles': this.idArticle
          },
          method: 'PUT'
        });
      } catch (error) {
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    async addItem() {
      await this.updateItems();
      try {
        await this.$http({
          url: process.env.VUE_APP_SERVER + 'api/articles/activities/add-item.php',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: {
            'id_articles': this.idArticle,
            'type': 1,
          },
          method: 'POST'
        });

        await this.loadData();

      } catch (error) {
        await this.loadData();
        console.log("error", error);
      }

    },
    async deleteItem(id) {
      await this.updateItems();
      try {
        if (confirm(this.$t('projects.deleteItem'))) {
          await this.$http({
            url: process.env.VUE_APP_SERVER + 'api/articles/activities/remove-item.php',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: {
              'id': id,
              'id_articles': this.idArticle
            },
            method: 'DELETE'
          });
          await this.loadData();
          this.$eventHub.$emit('openMessageController', 'success', this.$t('messages.deleted'));
        }

      } catch (error) {
        await this.loadData();
        console.log("error", error);
        this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
      }

    },
    removeCurrentItem(id){
      this.$set(this.totalsMap, id, 0);
      this.$emit("update-totals-map", this.getGrandTotal());
    },
    handleTotalUpdate({ id, total }) {
      this.$set(this.totalsMap, id, total); // reaktivní zápis
      this.$emit("update-totals-map", this.getGrandTotal());
    },
    getGrandTotal() {
      return Object.values(this.totalsMap).reduce((a, b) => a + b, 0);
    },

  },
  mounted() {
    this.loadData();
  },
}
</script>

<style lang="scss" scoped>
.w-50 {
  width: 50%;
}
</style>
